/**
 * User tests of A1 (docs/09-phase-0.md, P0-7): the time from opening the app to the first withdrawal
 * booked. Kept on this device only, shown under Status.
 */
const KEY = "lagerlog.a1";
const KEEP = 50;

let openedAt: number | null = Date.now();
document.addEventListener("visibilitychange", () => {
  if (document.visibilityState === "visible") openedAt = Date.now();
});

export function a1Times(): number[] {
  try {
    const list: unknown = JSON.parse(localStorage.getItem(KEY) ?? "[]");
    return Array.isArray(list) ? list.filter((t): t is number => typeof t === "number") : [];
  } catch {
    return [];
  }
}

/** Called when a withdrawal is booked; only the first one after each opening counts. */
export function withdrawalBooked() {
  if (openedAt === null) return;
  const times = [...a1Times(), Date.now() - openedAt].slice(-KEEP);
  openedAt = null;
  localStorage.setItem(KEY, JSON.stringify(times));
}

export function clearA1() {
  localStorage.removeItem(KEY);
}

export function median(times: number[]): number | null {
  if (times.length === 0) return null;
  const sorted = [...times].sort((a, b) => a - b);
  const mid = Math.floor(sorted.length / 2);
  return sorted.length % 2 ? sorted[mid]! : (sorted[mid - 1]! + sorted[mid]!) / 2;
}
